'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sellerDocumentLibraryComponent = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _marked = require('marked');

var _marked2 = _interopRequireDefault(_marked);

var _markedRenderer = require('./../../common/core/markedRenderer');

var _markedRenderer2 = _interopRequireDefault(_markedRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_marked2.default.setOptions({
    renderer: _markedRenderer2.default,
    breaks: false,
    sanitize: true
});

var sellerDocumentLibraryComponent = exports.sellerDocumentLibraryComponent = {
    template: require('./documentLibrary.html'),
    bindings: {
        documentCategories: '<',
        faq: '<'
    },
    controllerAs: 'vm',
    controller: ["config", "authService", function controller(config, authService) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.visibleDocumentCategories;
        vm.downloadFile = downloadFile;

        function init() {
            vm.faq = vm.faq || [];

            for (var i = 0; i < vm.faq.length; i++) {
                vm.faq[i] = Object.assign(vm.faq[i], {
                    answer: (0, _marked2.default)(vm.faq[i].answer || '')
                });
            }

            vm.documentCategories = vm.documentCategories || [];

            vm.visibleDocumentCategories = _lodash2.default.map(vm.documentCategories, function (c) {
                var filteredDocuments = _lodash2.default.filter(c.documents, function (i) {
                    return i.visible;
                });
                c.documents = filteredDocuments;
                return c;
            });
        }

        function downloadFile(documentId, documentTitle) {
            var url = config.webApiBaseUrl + 'sellers/DownloadFile/' + documentId + '?access_token=' + authService.accessToken;
            var link = document.createElement('a');
            link.download = documentTitle;
            link.href = url;
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/seller/documentLibrary.js
// module id = 1020
// module chunks = 0